export const AGENT_PASTED_TEXT_BLOCK_KIND = "pasted-text";
export const AGENT_PASTED_TEXT_MENTION_KIND = "pasted-text";
